import * as MapActionTypes from 'actiontypes/map';
import fetchMapSuccess from './fetchMapSuccess';
import setCurrentArea from './setCurrentArea';
import setCurrentSetting from './setCurrentSetting';
import { MAP_MIN_ZOOM } from 'components/Map/constants';
import { IMapState } from 'types/map';
import { IAction } from 'types/app';

/**
 * Initial state
 * @type {Object}
 */
const INITIAL_STATE: IMapState = {
  areas: [],
  canTravel: false,
  currentArea: undefined,
  fallbackMapPreferred: false,
  itemsUsableHere: false,
  isFetching: false,
  isMoving: false,
  isVisible: false,
  message: null,
  moveMessage: null,
  shouldUpdate: true,
  showOps: false,
  zoomLevel: MAP_MIN_ZOOM,
};


/**
 * Map Reducer
 * @param {Object} state
 * @param {[Object]} action
 */
const Map = (state = INITIAL_STATE, action: IAction) => {
  const { payload = {} } = action;

  switch (action.type) {
    case MapActionTypes.HIDE_MAP:
      return {
        ...state,
        isVisible: false,
      };

    case MapActionTypes.SHOW_MAP:
      return {
        ...state,
        isVisible: true,
      };

    case MapActionTypes.TOGGLE_MAP_VIEW:
      return {
        ...state,
        isVisible: !state.isVisible,
      };

    case MapActionTypes.FALLBACK_MAP_PREFERRED:
      return { ...state, fallbackMapPreferred: payload.value };

    case MapActionTypes.FETCH_MAP_REQUESTED:
      return { ...state, isFetching: true };

    case MapActionTypes.FETCH_MAP_FAILURE:
      return { ...state, isFetching: false };

    case MapActionTypes.FETCH_MAP_SUCCESS:
      return fetchMapSuccess(state, action);

    case MapActionTypes.CHANGE_LOCATION_REQUESTED:
      return {
        ...state,
        isMoving: true,
        moveMessage: null,
      };

    case MapActionTypes.CHANGE_LOCATION_FAILURE:
      return {
        ...state,
        isMoving: false,
        moveMessage: null,
      };

    case MapActionTypes.CHANGE_LOCATION_SUCCESS:
      return {
        ...state,
        message: payload.message,
        isMoving: false,
      };

    case MapActionTypes.SET_CURRENT_AREA:
      return setCurrentArea(state, payload);

    case MapActionTypes.SET_CURRENT_SETTING:
      return setCurrentSetting(state, payload);

    case MapActionTypes.SET_MAP_SHOULD_UPDATE:
      return {
        ...state,
        shouldUpdate: payload.shouldUpdate,
      };

    case MapActionTypes.SET_CAN_TRAVEL:
      return {
        ...state,
        canTravel: payload.canTravel,
      };

    default:
      return state;
  }
};

export default Map;
